import { combineEpics } from "redux-observable";
import { GEpic } from "stores";

const EPICS: GEpic[][] = [];


export const addEpics = (epics: GEpic[]) => EPICS.push(epics)

export const getEpicsForMiddleware = () => combineEpics(...EPICS.flat())